<template>
  <div class="dictionary column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div>字典名称：</div>
        <div class="width300">
          <el-input placeholder="请输入字典名称" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
      </div>
      <div class="margin-top20">
        <el-table :data="tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style">
          <el-table-column type="index" label="序号" align="center" width="200"></el-table-column>
          <el-table-column prop="name" label="字典名称" align="center"></el-table-column>
          <el-table-column label="操作列" align="center" width="200">
            <template #default="scope">
              <div class="row-me center-all" @click="clickDetail(scope.row)">
                <el-icon color="#215AA0">
                  <document/>
                </el-icon>
                <div class="blue-text">字典明细</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>


    <!-- 字典明细 -->
    <el-dialog title="字典明细" v-model="visible" width="50%" top="10vh" :destroy-on-close="true">
      <div class="padding10">
        <div class="btn-blue width140 btn-height40" @click="clickAdd()" v-if="canOperate">
          <el-icon>
            <plus/>
          </el-icon>
          新建
        </div>
        <div class="margin-top20">
          <el-table :data="tableDataDetail" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" height="60vh">
            <el-table-column prop="indexs" label="序号" align="center"></el-table-column>
            <el-table-column prop="name" label="字典项目" align="center"></el-table-column>
            <el-table-column label="操作列" align="center" width="280" v-if="canOperate">
              <template #default="scope">
                <div class="row-me center-all">
                  <div class="btn-blue width100 btn-height40" @click="clickEdit(scope.row)">
                    <el-icon>
                      <edit/>
                    </el-icon>
                    修改
                  </div>
                  <div class="btn-grey width100 btn-height40 margin-left20"
                       @click="clickDelete(scope.row)">
                    <el-icon>
                      <delete/>
                    </el-icon>
                    删除
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>


    <!-- 新建修改字典 -->
    <el-dialog :title="selectItem.id?'修改':'新建'" v-model="visibleAdd" width="40%" top="20vh"
               :destroy-on-close="true">
      <div class="padding10">
        <div class="row-me row-center">
          <div><span class="red-star">*</span>项目名称：</div>
          <div class="flex1 margin-left5">
            <el-input placeholder="请输入项目名称" style="width: 100%;" clearable v-model="selectItem.name"
                      :class="{'red-border':showRedBorder&&(selectItem.name===''||selectItem.name===null)}">
            </el-input>
          </div>
        </div>
        <div class="row-me margin-top30">
          <div><span class="red-star-div"></span>排列顺序：</div>
          <div class="column-me margin-left5">
            <div class="width300">
              <el-input placeholder="请输入排列顺序" style="width: 100%;" clearable v-model="selectItem.indexs"
                        @input="selectItem.indexs=$method.checkInput(selectItem.indexs,0)">
              </el-input>
            </div>
            <div class="row-me row-center">
              <img src="../../assets/img/tanhao.png" class="img-icon">
              <div class="tips">数值越大越靠前</div>
            </div>
          </div>
        </div>
        <div class="row-me row-center flex-end1 margin-top200">
          <div class="btn-blue width140 btn-height40" @click="clickSave">保存</div>
          <div class="btn-grey width140 btn-height40 margin-left20" @click="clickCancel">取消</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: '',
      tableData: [],
      visible: false,
      tableDataDetail: [],
      selectItem: {
        name: '',
        indexs: '',
      },
      visibleAdd: false,
      showRedBorder: false,
      cateId: '',
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getDictCate()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //查询
    clickSearch() {
      this.getDictCate()
    },
    //清空
    clickClear() {
      this.name = ''
      this.getDictCate()
    },
    //字典明细
    clickDetail(item) {
      this.cateId = item.code
      this.getDictionary()
      this.visible = true
    },
    //新建
    clickAdd() {
      this.showRedBorder = false
      this.selectItem = {
        type: this.cateId,
        name: '',
        indexs: '',
      }
      this.visibleAdd = true
    },
    //修改
    clickEdit(item) {
      this.selectItem = this.$method.deepClone(item)
      this.visibleAdd = true
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除【" + item.name + "】吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/dict/delete', [item.id]).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getDictionary()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //保存
    clickSave() {
      if (this.selectItem.name === '' || this.selectItem.name === null) {
        this.showRedBorder = true
        return
      }
      this.$postRequest('/admin/dict/update', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleAdd = false
          this.getDictionary()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //取消
    clickCancel() {
      this.visibleAdd = false
    },
    //获取字典类别
    getDictCate() {
      this.$getRequest('/admin/dict/getDictCate', {
        name: this.name,
      }).then((res) => {
        if (res) {
          this.tableData = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取字典类别
    getDictionary() {
      this.$getRequest('/admin/dict/list', {
        type: this.cateId
      }).then((res) => {
        if (res) {
          this.tableDataDetail = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.dictionary {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .tips {
    font-size: 14px;
    color: #A9B6C4;
  }
}
</style>
